import { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";

// Batch-read other anglers' public avatars (publicProfiles/{uid}), cached.
//
// users/{uid} is self-only under firestore.rules, so we can't read another
// angler's photoURL directly. The mirror_public_profile Cloud Function keeps
// a public-readable publicProfiles/{uid} mirror ({ displayName, photoURL });
// this hook reads it for a set of uids and returns a { uid: {photoURL,
// displayName} } map.

const cache = new Map(); // uid -> { photoURL, displayName }

export default function useUserPhotos(uids) {
  const list = Array.isArray(uids) ? Array.from(new Set(uids.filter(Boolean).map(String))) : [];
  const key = list.join(",");
  const [map, setMap] = useState({});

  useEffect(() => {
    const ids = key ? key.split(",") : [];
    if (!ids.length) {
      setMap({});
      return undefined;
    }
    let cancelled = false;

    (async () => {
      const result = {};
      await Promise.all(
        ids.map(async (uid) => {
          if (cache.has(uid)) {
            result[uid] = cache.get(uid);
            return;
          }
          try {
            const snap = await getDoc(doc(db, "publicProfiles", uid));
            const data = snap.exists() ? snap.data() || {} : {};
            const entry = {
              photoURL: data.photoURL || "",
              displayName: data.displayName || "",
            };
            cache.set(uid, entry);
            result[uid] = entry;
          } catch {
            result[uid] = { photoURL: "", displayName: "" };
          }
        })
      );
      if (!cancelled) setMap(result);
    })();

    return () => {
      cancelled = true;
    };
  }, [key]);

  return map;
}
